<script type="text/jsx">
export default {
    functional: true,
    render(h, { children, data }) {
        return <div {...data} class="mt-xxs text-5"> { children } </div>;
    },
};
</script>
